<aside
  class="fixed left-0 top-0 z-9999 flex h-screen w-0 flex-col overflow-y-hidden border-r border-gray-200 bg-white px-0 lg:static lg:translate-x-0">
  <!-- SIDEBAR HEADER -->
  <div class="flex items-center gap-2 mt-7 sidebar-header mb-5 relative header-sidebar">
    <button class="lg:hidden w-[20px] h-[20px] absolute right-0 top-0 justify-center items-center flex"
      (click)="closeMenu()">
      <i class="pi pi-times text-gray-400" style="font-size: 1.5rem"></i>
    </button>
    <a href="/">
      <img class="w-35" src="./assets/img/brand.svg" alt="Ruport" />
    </a>
  </div>
  @if(showOfficeSelector){
  <div class="flex flex-col header-sidebar">
    <app-office-selector class="w-1/1 mb-5"></app-office-selector>
  </div>
  }
  <!-- SIDEBAR HEADER -->

  <div class="flex flex-col overflow-y-auto duration-300 ease-linear body-sidebar">
    <!-- Sidebar Menu -->
    <nav>
      <!-- Menu Group -->
      <ng-container *ngFor="let section of menu">
        <div *ngIf="(section.active || section.active == null) && section.options!.length > 0">
          <h3 *ngIf="section.section" class="mb-4 text-xs uppercase leading-[20px] text-gray-400">
            <span class="menu-group-title">
              {{section.section}}
            </span>
          </h3>

          <ul class="flex flex-col gap-2 mb-6">
            <!-- Menu Item Dashboard -->
            <ng-container *ngFor="let option of section.options">
              <li *ngIf="option.active">
                <a [routerLink]="option.link" [routerLinkActive]="'menu-item-active'" (click)="closeMenuForMobile()"
                  *ngIf="!option.options || option.options?.length == 0" class="menu-item group menu-item-inactive">
                  <i [ngClass]="option.icon" class="menu-item-icon-inactive text-lg"
                    [routerLinkActive]="'menu-item-icon-active'"></i>

                  <span class="menu-item-text">
                    {{option.label}}
                  </span>
                </a>

                <div [class.menu-item-active]="option.opened" class="menu-item group menu-item-inactive"
                  *ngIf="option.options && option.options!.length > 0 && option.active"
                  (click)="option.opened = !option.opened">
                  <i [ngClass]="option.icon" class="menu-item-icon-inactive text-lg"
                    [routerLinkActive]="'menu-item-icon-active'"></i>

                  <span class="menu-item-text">
                    {{option.label}}
                  </span>

                  <svg class="menu-item-arrow"
                    [class.menu-item-arrow-inactive]="option.options && option.options.length > 0"
                    [class.menu-item-arrow-active]="option.opened" width="20" height="20" viewBox="0 0 20 20"
                    fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.79175 7.39584L10.0001 12.6042L15.2084 7.39585" stroke="" stroke-width="1.5"
                      stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>

                <!-- Dropdown Menu Start -->
                <div *ngIf="option.options && option.options!.length > 0 && option.opened"
                  class="overflow-hidden transform translate hidden" [class.block]="option.opened">
                  <ul class="flex flex-col gap-1 mt-2 menu-dropdown pl-9">
                    <li *ngFor="let suboption of option.options">
                      <a [routerLink]="suboption.link" (click)="closeMenuForMobile()"
                        [routerLinkActive]="'menu-dropdown-item-active'"
                        class="menu-dropdown-item group menu-item-inactive">
                        {{suboption.label}}
                      </a>
                    </li>
                  </ul>
                </div>
                <!-- Dropdown Menu End -->
              </li>
            </ng-container>
            <!-- Menu Item Dashboard -->
          </ul>
        </div>
      </ng-container>

    </nav>
    <!-- Sidebar Menu -->
  </div>
</aside>